import React, { useEffect, useRef, useState } from "react";
import { IoLocationSharp, IoCallOutline, IoMailOutline } from "react-icons/io5";
import { useDispatch, useSelector, connect } from "react-redux";
import { getCall, getCities } from "../../Redux/Actions";
import { GET_CALL_RESET } from "../../Redux/Constants";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import Footer from "../Footer/Footer";
import "./ContactUs.css";
import { BrowserRouter as Router, Switch, useLocation } from "react-router-dom";
import NewHeader from "../NewHeader/NewHeader";
import PatientActions from "../Cart/PatientDetailsAction";
import { Helmet } from "react-helmet";

// import SamBanerDesktop from "../Assets/ContactUs/SHUBHAM_Mesa_de_trabajo_1.png";

function NewContactUs(props) {
  const location = useLocation();

  var url = `https://redcliffelabs.com` + location.pathname;
  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;

  const [cityFocus, setCityFocus] = useState(false);

  const callRecieve = useSelector((state) => state.callRecieve);
  const { success } = callRecieve;

  const cityList = useSelector((state) => state.cityList);
  const { cities, loading } = cityList;
  var headerImage = require("../../Assets/ContactUs/Group8948.png");
  const timer = useRef(0);

  const dispatch = useDispatch();

  const [Name, setName] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [City, setCity] = useState("");
  const [PurposeContact, setPurposeContact] = useState("");
  const [ContactText, setContactText] = useState("");
  const [message, setMessage] = useState("");
  const [NameErr, setNameErr] = useState("");
  const [MobileErr, setMobileErr] = useState("");
  const [EmailErr, setEmailErr] = useState("");
  const [CityErr, setCityErr] = useState("");
  const [PurposeContactErr, setPurposeContactErr] = useState("");
  const [ContactTextErr, setContactTextErr] = useState("");

  const initailValue = {
    name: "",
    mobile: "",
    email: "",
    city: "",
    contact: "",
    text: "",
  };

  const [contactUsFormValue, setContactUs] = useState(initailValue);
  const [isSubmit, setIsSubmit] = useState(false);
  const [filteredCityArray, setFilterCityArray] = useState([]);
  const [dropDown, setDropDown] = useState(false);
  // const [contactUsFormError, setContactUsFError] = useState({});
  useEffect(() => {
    dispatch(getCities());
  }, []);

  const contactUsNameHandle = (e) => {
    setName(e.target.value);
    const { name, value } = e.target;
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    setNameErr("");
    if (!e.target.value.match(characterRegex)) {
      setNameErr("Invalid user name");
      setContactUs({ ...contactUsFormValue, [name]: "" });
    } else {
      setContactUs({ ...contactUsFormValue, [name]: value });
    }
    if (e.target.value == "") {
      setNameErr("");
    }
  };
  const contactUsMobileHandle = (e) => {
    setMobile(e.target.value);
    const { name, value } = e.target;
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    let phoneno = /^\d{10}$/;
    if (
      !e.target.value.match(phoneno) &&
      e.target.value.match(characterRegex)
    ) {
      setMobileErr("Enter a valid mobile number");
      setContactUs({ ...contactUsFormValue, [name]: "" });
    }
    if (e.target.value.length != 10 && !e.target.value.match(characterRegex)) {
      setMobileErr("Enter a valid mobile number");
      setContactUs({ ...contactUsFormValue, [name]: "" });
    }
    if (e.target.value.charAt(0) < 6 && !e.target.value.match(characterRegex)) {
      setMobileErr("Enter a valid mobile number");
      setContactUs({ ...contactUsFormValue, [name]: "" });
    }
    if (
      e.target.value.length == 10 &&
      e.target.value.charAt(0) >= 6 &&
      !e.target.value.match(characterRegex)
    ) {
      setMobileErr("");
      setContactUs({ ...contactUsFormValue, [name]: value });
    }
    if (e.target.value == "") {
      setMobileErr("");
    }
  };
  const contactUsEmailHandle = (e) => {
    setEmail(e.target.value);
    const { name, value } = e.target;

    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!e.target.value) {
      setEmailErr("Email is required.");
    }
    if (!regex.test(e.target.value)) {
      // errors.email = "This is not a valid Email Format";
      setEmailErr("This is not a valid Email Format");
      setContactUs({ ...contactUsFormValue, [name]: "" });
    } else {
      setEmailErr("");
      setContactUs({ ...contactUsFormValue, [name]: value });
    }
    if (e.target.value == "") {
      setEmailErr("");
      setContactUs({ ...contactUsFormValue, [name]: "" });
    }
  };
  // const contactUsCityHandle = (e)=>{
  // 	setCity(e.target.value);
  // 	clearTimeout(timer);
  //     const { name, value } = e.target;
  //     const characterRegex =/^([A-Za-z]+[ ]?)+$/;
  //     // setCity("");
  //     if (!e.target.value.match(characterRegex)) {
  //       	setCityErr("Invalid City Name");
  //       	setContactUs({ ...contactUsFormValue, [name]: "" });
  //     }else{
  //       	setContactUs({ ...contactUsFormValue, [name]: value });
  // 		console.log(contactUsFormValue,'contact cityyy valeee')
  //     }
  //     if (e.target.value == "") {
  //       	setCityErr("");
  //     }
  // }
  const contactUsPContactHandle = (e) => {
    setDropDown(true);
    setPurposeContact(e.target.value);
    const { name, value } = e.target;
    setPurposeContactErr("");
    if (e.target.value == "none") {
      setPurposeContactErr("Select the purpose contact");
      setContactUs({ ...contactUsFormValue, [name]: "" });
    } else {
      setContactUs({ ...contactUsFormValue, [name]: value });
      console.log(contactUsFormValue, "contact purposeee valeee");
    }
  };
  const contactUsTextHandle = (e) => {
    setContactText(e.target.value);
    const { name, value } = e.target;
    setContactUs({ ...contactUsFormValue, [name]: value });
    setContactTextErr("");
  };

  const contactUsCityHandle = (e) => {
    setCity(e.target.value);
    const { name, value } = e.target;
    const characterRegex = /^[A-Za-z0-9 ]+$/;
    clearTimeout(timer);

    setCityErr("");
    if (!e.target.value.match(characterRegex)) {
      setCityFocus(false);
      setCityErr("Invalid city name");
      setContactUs({ ...contactUsFormValue, [name]: "" });
    } else {
      setCityFocus(true);
      setCityErr("");
      setContactUs({ ...contactUsFormValue, [name]: value });
      console.log(City, "cityyy");
    }
    if (e.target.value == "") {
      setCityErr("");
      setCityFocus(false);
    }
  };

  const submitContactForm = (e) => {
    if (
      contactUsFormValue.name != "" &&
      contactUsFormValue.mobile != "" &&
      City != "" &&
      contactUsFormValue.contact != "" &&
      contactUsFormValue.email != "" &&
      contactUsFormValue.text != ""
    ) {
      const body = {
        name: contactUsFormValue.name,
        phone_no: contactUsFormValue.mobile,
        optin: true,
        source: "Ecommerce",
        city: City,
        email: contactUsFormValue.email,
        message: contactUsFormValue.text,
        url,
      };
      setIsSubmit(true);
      dispatch(getCall(body));
      // console.log("arePIN" , areApin ,patientDFormValue );
      // localStorage.setItem("patientDetail", JSON.stringify(patientDFormValue));
    } else {
      if (Name == "") {
        setNameErr("Name is required");
      }
      if (Email == "") {
        setEmailErr("Email is required");
      }
      if (Mobile == "") {
        setMobileErr("Mobile is required");
      }
      if (City == "") {
        setCityErr("City is required");
      }
      if (PurposeContact == "") {
        setPurposeContactErr("Select the purpose contact");
      }
      if (ContactText == "") {
        setContactTextErr("Text is required");
      }
    }
  };

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal?.token;
    if (token) {
      props?.getProfileDetails(token);
    }
  }, []);

  useEffect(() => {
    if (
      props?.userProfile?.username &&
      props?.userProfile?.fullname &&
      props?.userProfile?.email
    ) {
      setContactUs({
        ...contactUsFormValue,
        name: props?.userProfile?.fullname,
        mobile: props?.userProfile?.phonenumber,
        email: props?.userProfile?.email,
      });
      setMobile(props?.userProfile?.phonenumber);
      setName(props?.userProfile?.fullname);
      setEmail(props?.userProfile?.email);
    }
    return;
  }, [props?.userProfile]);

  useEffect(() => {
    if (success) {
      setName("");
      setMobile("");
      setCity("");
      setEmail("");
      setCity("");
      setCityErr("");
      setContactText("");
      setPurposeContact("");
      setMessage("Your form has been submitted successfully");
      setTimeout(() => {
        dispatch({
          type: GET_CALL_RESET,
        });
        setMessage("");
      }, 5000);
    }
  }, [success]);

  // const contactUsFValidate=(value)=>{
  //     const errors = {};
  //     const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  //     if(!value.name){
  //       errors.name = "Patient name is required ";
  //     }else if (!value.name.match(/^[a-zA-Z]+$/)){
  //       errors.name = "Number not allow in name. ";
  //     }
  //     if(!value.mobile){
  //       errors.mobile = "Mobile Number is required ";
  //     }else if (value.mobile.length !=10){
  //       errors.mobile = "Mobile Number is required 10 digit.";
  //     }
  //     if(!value.city){
  //       errors.city = "City name is required ";
  //     }else if (!value.city.match(/^[a-zA-Z]+$/)){
  //       errors.city = "Number not allow in city name. ";
  //     }
  //     if(!value.contact){
  //       errors.contact = "Contact is required";
  //     }
  //     if(!value.text){
  //       errors.text = "Text is required ";
  //     }
  //     if(!value.email){
  //       errors.email = "Email is required ";
  //     }else if(!regex.test(value.email)){
  //       errors.email = "This is not a valid Email Format"
  //     }

  //     return errors;
  // }

  const [showInc, setInc] = useState(false);
  const showInclusion = () => {
    setInc(!showInc);
  };

  return (
    <>
      <Helmet>
        <title>
          Contact Us: Our Experts & Support Team is here to answer any and all
          of your queries.
        </title>
        <meta
          name="description"
          content="Our experts & support team is here to answer any and all of your queries. For Further details Contact us at 898 898 8787."
        />
      </Helmet>

      <NewHeader />
      <div className="contact_usDiv">
        <div className="Main_container">
          <div className="contactLeftSide">
            <h1>Contact Us</h1>
            <p className="MobileView">Need Help?</p>
            <span className="MobileView">We would love to hear from you!</span>
            <p className="WebView">
              Need Help? We would love to hear from you!
            </p>
          </div>
          <div className="contactRightSide"></div>
        </div>
      </div>
      <div className="contact_usForm">
        <div className="contact_Address">
          <div className="urls">
            <span className="homeUrl">Home</span>
            <span className="borderUrl"></span>
            <span className="ContactUrl">Contact Us</span>
          </div>
          <div className="mobile_urls">
            <span className="Contact_Url">Contact Us</span>
          </div>
          <div className="addressDiv">
            <h2>Redcliffe Labs</h2>
            <p>H55 3rd floor, Electronic City Noida, Uttar Pradesh, 201301</p>
            <span className="locationIcon">
              <IoLocationSharp />
            </span>
            <a href="https://g.page/Redcliffe-Labs?share" target="_blank">
              <span className="address_heading getDirectionULine">
                Get Directions
              </span>
            </a>
            <p></p>
            <a href="tel:+91 898 898 8787">
              {" "}
              <span className="address_icon">
                <IoCallOutline />
              </span>
              <span className="address_heading">+91 898 898 8787</span>
            </a>
            <p>Call our Experts</p>
            <a href="mailto:contact@redcliffelabs.com">
              <span className="address_icon">
                <IoMailOutline />
              </span>
              <span className="address_heading">contact@redcliffelabs.com</span>
            </a>
            <p>Email us</p>
          </div>
        </div>
        <div className="contact_Form">
          <p>
            Our experts & support team is here to answer any and all of your
            queries.
          </p>
          <div className="contactSForm">
            <div className="bottom_form">
              <div className="d_flex flex_column">
                <label className="labels">ENTER NAME</label>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter Name"
                  className="contactInput"
                  value={Name}
                  onChange={contactUsNameHandle}
                  autoComplete="off"
                />
                <span
                  style={{
                    color: "red",
                    marginBottom: "12px",
                    position: "absolute",
                    fontSize: "13px",
                    bottom: "-25px",
                  }}
                >
                  {NameErr}
                </span>
              </div>
              <div className="d_flex flex_column ">
                <label className="labels">MOBILE NUMBER</label>
                <input
                  type="number"
                  name="mobile"
                  placeholder="Enter Mobile Number"
                  className="contactInput"
                  value={Mobile}
                  onChange={contactUsMobileHandle}
                />
                <span
                  style={{
                    color: "red",
                    marginBottom: "12px",
                    position: "absolute",
                    fontSize: "13px",
                    bottom: "-25px",
                  }}
                >
                  {MobileErr}
                </span>
              </div>
            </div>
            <div className="bottom_form">
              <div className="d_flex flex_column">
                <label className="labels">EMAIL ID</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter Email Id"
                  className="contactInput"
                  value={Email}
                  onChange={contactUsEmailHandle}
                />

                <span
                  style={{
                    color: "red",
                    marginBottom: "12px",
                    position: "absolute",
                    fontSize: "13px",
                    bottom: "-25px",
                  }}
                >
                  {EmailErr}
                </span>
              </div>
              <div
                className="d_flex flex_column "
                style={{ position: "relative" }}
              >
                <label className="labels">ENTER CITY</label>
                <input
                  type="text"
                  name="city"
                  placeholder="Enter City"
                  className="contactInput"
                  value={City}
                  onBlur={() => {
                    setTimeout(() => {
                      setCityFocus(false);
                    }, 500);
                  }}
                  onFocus={() => setCityFocus(true)}
                  onChange={contactUsCityHandle}
                />
                {City && City !== "" && cityFocus && (
                  <div className="cityList">
                    {loading ? (
                      <h5></h5>
                    ) : (
                      cityFocus &&
                      citiesFromArray &&
                      citiesFromArray.cities
                        .filter((name) => {
                          if (City == "") {
                            return name;
                          } else if (
                            name.toLowerCase().includes(City.toLowerCase())
                          ) {
                            return name;
                          }
                        })
                        .map((filteredName, index) => {
                          if (index <= 1) {
                            return (
                              <div
                                className="cityItem"
                                key={index}
                                onClick={() => setCity(filteredName)}
                              >
                                {" "}
                                <span>{filteredName}</span>{" "}
                              </div>
                            );
                          }
                        })
                    )}
                  </div>
                )}
                <span
                  style={{
                    color: "red",
                    marginBottom: "12px",
                    position: "absolute",
                    fontSize: "13px",
                    bottom: "-25px",
                  }}
                >
                  {CityErr}
                </span>
              </div>
            </div>

            <div className="d_flex flex_column " onClick={showInclusion}>
              <label className="labels">PURPOSE OF CONTACT</label>
              {/* {dropDown!=true  */}
              {/* <div className="pacDrop" onClick={showInclusion}>
              <span>{!showInc ? <BsChevronDown /> : <BsChevronUp />}</span>
              </div> */}
              <select
                className="contactSelect selectDropNew "
                name="contact"
                value={PurposeContact}
                onChange={contactUsPContactHandle}
                defaultValue={"none"}
                required
              >
                <option value="none">Select the reason</option>
                <option value="Incomplete Order">Incomplete Order</option>
                <option value="Upload Prescription Issue">
                  Upload Prescription Issue
                </option>
                <option value="Website Issue">Website Issue</option>
                <option value="Diagnostic Related">Diagnostic Related</option>
              </select>

              <span
                style={{
                  color: "red",
                  marginBottom: "12px",
                  position: "absolute",
                  fontSize: "13px",
                  bottom: "-15px",
                }}
              >
                {PurposeContactErr}
              </span>
            </div>

            <div className="d_flex flex_column textarea">
              <label className="labels">ENTER YOUR TEXT</label>
              <textarea
                name="text"
                placeholder="Max 500 Characters"
                value={ContactText}
                onChange={contactUsTextHandle}
              />

              <span
                style={{
                  color: "red",
                  marginBottom: "12px",
                  position: "absolute",
                  fontSize: "13px",
                  bottom: "-25px",
                }}
              >
                {ContactTextErr}
              </span>
            </div>
            <div className="successDiv">
              {" "}
              {success && (
                <p style={{ color: "green", fontSize: "15px" }}>{message}</p>
              )}
            </div>

            <button
              className="contact_form_submit"
              type="submit"
              onClick={submitContactForm}
            >
              SUBMIT FEEDBACK
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfileDetails: (token) => {
      dispatch(PatientActions.getProfileDetails(token));
    },
  };
};

export default {
  component: connect(
    mapStateToProps,
    mapDispatchToProps
  )(React.memo(NewContactUs)),
};
